// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pwa_container {\n  aspect-ratio: 17/5;\n}\n.pwa_container .slider-comp {\n  width: 100%;\n  height: 100%;\n}\n\n@media screen and (max-width: 578px) {\n  .pwa_container {\n    aspect-ratio: 10/8;\n  }\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
